import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import { updateChoice, setModalPanelIndex } from "areas/product/store/actions"
import { to_currency } from "helpers/number"
import { filterProductOptions } from "helpers/product/product-filtering"
import { useNavigation } from "helpers/use-navigation"

import {
  ChoiceOption,
  GradientContainer,
  OptionsSlider,
  OptionImage,
  OptionTitle,
  OptionPrice,
} from "./components"

const ChoiceOptions = ({
  sizeFilter,
  skuFiltered,
  selectedValue,
  setChoice,
  data,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider
      aria-label={`${data.heading.title}s`}
      data-slider="true"
      role="radiogroup"
    >
      {skuFiltered
        .filter((option) => {
          return (
            !option.size_filter ||
            option.size_filter === "" ||
            option.size_filter === sizeFilter
          )
        })
        .map((addition) => {
          const selected = selectedValue == addition.value
          return (
            <ChoiceOption
              aria-selected={selected}
              data-cy={`product-wizard-option-${data.pref}-${addition.value}`}
              data-is-option="true"
              data-is-selected={selected}
              key={`sliderAdditionOption-${addition.value}`}
              onClick={(e) => {
                setChoice(data.pref, addition, e)
              }}
              role="radio"
              selected={selected}
              tabIndex={selected ? 0 : -1}
              {...keyboardProps}
            >
              <OptionImage
                alt={addition.title}
                height="40px"
                sizes="40px"
                src={addition.image || require("images/icons/jewlr.gif")}
                srcSet={addition.image}
                title={addition.title}
                width="40px"
              />
              <OptionTitle>{addition.title}</OptionTitle>
              <OptionPrice>
                {addition.price > 0 ? to_currency(addition.price) : ""}
              </OptionPrice>
            </ChoiceOption>
          )
        })}
    </OptionsSlider>
  )
}

ChoiceOptions.propTypes = {
  data: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
  sizeFilter: PropTypes.string,
  skuFiltered: PropTypes.array,
}

const InternalAdditionsOption = ({
  data,
  selectedValue,
  setChoice,
  filter,
  sizeFilter,
}) => {
  if (!data || data.disabled) {
    return null
  }
  const skuFiltered = filterProductOptions(data.options, filter, true)
  return (
    <GradientContainer>
      <FocusScope>
        <ChoiceOptions
          data={data}
          selectedValue={selectedValue}
          setChoice={setChoice}
          sizeFilter={sizeFilter}
          skuFiltered={skuFiltered}
        />
      </FocusScope>
    </GradientContainer>
  )
}
InternalAdditionsOption.propTypes = {
  data: PropTypes.object,
  filter: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
  sizeFilter: PropTypes.string,
}

const getFilter = (state) => {
  const sku =
    state.choices && state.choices.sku ? state.choices.sku.value || "" : ""
  return {
    pref: "sku",
    value: sku,
  }
}

const getSizeFilter = (state) => {
  const size =
    state.choices && state.choices.sz ? state.choices.sz.value || "" : ""
  return size
  // return {
  //   pref: 'sz',
  //   value: size
  // }
}

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.wizard.data[ownProps.pref],
    filter: getFilter(state),
    selectedValue: state.choices[ownProps.pref]
      ? state.choices[ownProps.pref].value || ""
      : "",
    sizeFilter: getSizeFilter(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
      try {
        if (data.linked_option && data.linked_option != "") {
          dispatch(setModalPanelIndex(data.linked_option))
        }
      } catch (err) {
        console.log("LINKED OPTION ERROR:", err)
      }
    },
  }
}

const AdditionsOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAdditionsOption)

export default AdditionsOptions
